module.exports = {
  "contractName": "NiftyFactory",
  "abi": [{
    "constant": true,
    "inputs": [],
    "name": "implementation",
    "outputs": [{
      "name": "",
      "type": "address"
    }],
    "payable": false,
    "stateMutability": "view",
    "type": "function",
    "signature": "0x5c60da1b"
  }, {
    "inputs": [{
      "name": "_implementation",
      "type": "address"
    }],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "constructor",
    "signature": "constructor"
  }, {
    "anonymous": false,
    "inputs": [{
      "indexed": true,
      "name": "owner",
      "type": "address"
    }, {
      "indexed": false,
      "name": "token",
      "type": "address"
    }, {
      "indexed": false,
      "name": "name",
      "type": "string"
    }, {
      "indexed": false,
      "name": "symbol",
      "type": "string"
    }, {
      "indexed": false,
      "name": "metadata",
      "type": "string"
    }],
    "name": "Created",
    "type": "event",
    "signature": "0x6744faaed907c9d2d0836148b1665c7e892b5b37add243829c5369afd3ff51f0"
  }, {
    "constant": false,
    "inputs": [{
      "name": "_name",
      "type": "string"
    }, {
      "name": "_symbol",
      "type": "string"
    }, {
      "name": "_metadata",
      "type": "string"
    }],
    "name": "create",
    "outputs": [],
    "payable": false,
    "stateMutability": "nonpayable",
    "type": "function",
    "signature": "0x5d28560a"
  }],
  "bytecode": "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",
  "deployedBytecode": "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",
  "sourceMap": "117:515:1:-;;;278:80;8:9:-1;5:2;;;30:1;27;20:12;5:2;278:80:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;338:15;321:14;;:32;;;;;;;;;;;;;;;;;;278:80;117:515;;;;;;",
  "deployedSourceMap": "117:515:1:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;244:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;244:29:1;;;;;;;;;;;;;;;;;;;;;;;;;;;362:268;;8:9:-1;5:2;;;30:1;27;20:12;5:2;362:268:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;244:29;;;;;;;;;;;;;:::o;362:268::-;439:11;483:14;;;;;;;;;;;459:39;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;459:39:1;439:60;;505:5;:16;;;522:10;534:5;541:7;550:9;505:55;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;505:55:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;505:55:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;505:55:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;505:55:1;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;505:55:1;;;;580:10;572:53;;;592:5;599;606:7;615:9;572:53;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;572:53:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;572:53:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;572:53:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;362:268;;;;:::o;117:515::-;;;;;;;;;;:::o",
  "source": "pragma solidity ^0.4.18;\n\nimport \"zos-lib/contracts/upgradeability/UpgradeabilityProxy.sol\";\n\nimport \"./Nifty.sol\";\n\ncontract NiftyFactory {\n  event Created(address indexed owner, address token, string name, string symbol, string metadata);\n\n  address public implementation;\n\n  constructor(address _implementation) {\n    implementation = _implementation;\n  }\n\n  function create(string _name, string _symbol, string _metadata) public {\n    Nifty token = Nifty(new UpgradeabilityProxy(implementation));\n    token.initialize(msg.sender, _name, _symbol, _metadata);\n\n    emit Created(msg.sender, token, _name, _symbol, _metadata);\n  }\n}\n",
  "sourcePath": "/Users/sfeibus/fs/libraries/statesauce/nifty-supply/packages/contracts/contracts/NiftyFactory.sol",
  "ast": {
    "absolutePath": "/Users/sfeibus/fs/libraries/statesauce/nifty-supply/packages/contracts/contracts/NiftyFactory.sol",
    "exportedSymbols": {
      "NiftyFactory": [169]
    },
    "id": 170,
    "nodeType": "SourceUnit",
    "nodes": [{
      "id": 104,
      "literals": ["solidity", "^", "0.4", ".18"],
      "nodeType": "PragmaDirective",
      "src": "0:24:1"
    }, {
      "absolutePath": "zos-lib/contracts/upgradeability/UpgradeabilityProxy.sol",
      "file": "zos-lib/contracts/upgradeability/UpgradeabilityProxy.sol",
      "id": 105,
      "nodeType": "ImportDirective",
      "scope": 170,
      "sourceUnit": 1601,
      "src": "26:66:1",
      "symbolAliases": [],
      "unitAlias": ""
    }, {
      "absolutePath": "/Users/sfeibus/fs/libraries/statesauce/nifty-supply/packages/contracts/contracts/Nifty.sol",
      "file": "./Nifty.sol",
      "id": 106,
      "nodeType": "ImportDirective",
      "scope": 170,
      "sourceUnit": 103,
      "src": "94:21:1",
      "symbolAliases": [],
      "unitAlias": ""
    }, {
      "baseContracts": [],
      "contractDependencies": [1600],
      "contractKind": "contract",
      "documentation": null,
      "fullyImplemented": true,
      "id": 169,
      "linearizedBaseContracts": [169],
      "name": "NiftyFactory",
      "nodeType": "ContractDefinition",
      "nodes": [{
        "anonymous": false,
        "documentation": null,
        "id": 118,
        "name": "Created",
        "nodeType": "EventDefinition",
        "parameters": {
          "id": 117,
          "nodeType": "ParameterList",
          "parameters": [{
            "constant": false,
            "id": 108,
            "indexed": true,
            "name": "owner",
            "nodeType": "VariableDeclaration",
            "scope": 118,
            "src": "157:21:1",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_address",
              "typeString": "address"
            },
            "typeName": {
              "id": 107,
              "name": "address",
              "nodeType": "ElementaryTypeName",
              "src": "157:7:1",
              "typeDescriptions": {
                "typeIdentifier": "t_address",
                "typeString": "address"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 110,
            "indexed": false,
            "name": "token",
            "nodeType": "VariableDeclaration",
            "scope": 118,
            "src": "180:13:1",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_address",
              "typeString": "address"
            },
            "typeName": {
              "id": 109,
              "name": "address",
              "nodeType": "ElementaryTypeName",
              "src": "180:7:1",
              "typeDescriptions": {
                "typeIdentifier": "t_address",
                "typeString": "address"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 112,
            "indexed": false,
            "name": "name",
            "nodeType": "VariableDeclaration",
            "scope": 118,
            "src": "195:11:1",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 111,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "195:6:1",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 114,
            "indexed": false,
            "name": "symbol",
            "nodeType": "VariableDeclaration",
            "scope": 118,
            "src": "208:13:1",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 113,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "208:6:1",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 116,
            "indexed": false,
            "name": "metadata",
            "nodeType": "VariableDeclaration",
            "scope": 118,
            "src": "223:15:1",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 115,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "223:6:1",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }],
          "src": "156:83:1"
        },
        "src": "143:97:1"
      }, {
        "constant": false,
        "id": 120,
        "name": "implementation",
        "nodeType": "VariableDeclaration",
        "scope": 169,
        "src": "244:29:1",
        "stateVariable": true,
        "storageLocation": "default",
        "typeDescriptions": {
          "typeIdentifier": "t_address",
          "typeString": "address"
        },
        "typeName": {
          "id": 119,
          "name": "address",
          "nodeType": "ElementaryTypeName",
          "src": "244:7:1",
          "typeDescriptions": {
            "typeIdentifier": "t_address",
            "typeString": "address"
          }
        },
        "value": null,
        "visibility": "public"
      }, {
        "body": {
          "id": 129,
          "nodeType": "Block",
          "src": "315:43:1",
          "statements": [{
            "expression": {
              "argumentTypes": null,
              "id": 127,
              "isConstant": false,
              "isLValue": false,
              "isPure": false,
              "lValueRequested": false,
              "leftHandSide": {
                "argumentTypes": null,
                "id": 125,
                "name": "implementation",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 120,
                "src": "321:14:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }
              },
              "nodeType": "Assignment",
              "operator": "=",
              "rightHandSide": {
                "argumentTypes": null,
                "id": 126,
                "name": "_implementation",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 122,
                "src": "338:15:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }
              },
              "src": "321:32:1",
              "typeDescriptions": {
                "typeIdentifier": "t_address",
                "typeString": "address"
              }
            },
            "id": 128,
            "nodeType": "ExpressionStatement",
            "src": "321:32:1"
          }]
        },
        "documentation": null,
        "id": 130,
        "implemented": true,
        "isConstructor": true,
        "isDeclaredConst": false,
        "modifiers": [],
        "name": "",
        "nodeType": "FunctionDefinition",
        "parameters": {
          "id": 123,
          "nodeType": "ParameterList",
          "parameters": [{
            "constant": false,
            "id": 122,
            "name": "_implementation",
            "nodeType": "VariableDeclaration",
            "scope": 130,
            "src": "290:23:1",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_address",
              "typeString": "address"
            },
            "typeName": {
              "id": 121,
              "name": "address",
              "nodeType": "ElementaryTypeName",
              "src": "290:7:1",
              "typeDescriptions": {
                "typeIdentifier": "t_address",
                "typeString": "address"
              }
            },
            "value": null,
            "visibility": "internal"
          }],
          "src": "289:25:1"
        },
        "payable": false,
        "returnParameters": {
          "id": 124,
          "nodeType": "ParameterList",
          "parameters": [],
          "src": "315:0:1"
        },
        "scope": 169,
        "src": "278:80:1",
        "stateMutability": "nonpayable",
        "superFunction": null,
        "visibility": "public"
      }, {
        "body": {
          "id": 167,
          "nodeType": "Block",
          "src": "433:197:1",
          "statements": [{
            "assignments": [140],
            "declarations": [{
              "constant": false,
              "id": 140,
              "name": "token",
              "nodeType": "VariableDeclaration",
              "scope": 168,
              "src": "439:11:1",
              "stateVariable": false,
              "storageLocation": "default",
              "typeDescriptions": {
                "typeIdentifier": "t_contract$_Nifty_$102",
                "typeString": "contract Nifty"
              },
              "typeName": {
                "contractScope": null,
                "id": 139,
                "name": "Nifty",
                "nodeType": "UserDefinedTypeName",
                "referencedDeclaration": 102,
                "src": "439:5:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_contract$_Nifty_$102",
                  "typeString": "contract Nifty"
                }
              },
              "value": null,
              "visibility": "internal"
            }],
            "id": 147,
            "initialValue": {
              "argumentTypes": null,
              "arguments": [{
                "argumentTypes": null,
                "arguments": [{
                  "argumentTypes": null,
                  "id": 144,
                  "name": "implementation",
                  "nodeType": "Identifier",
                  "overloadedDeclarations": [],
                  "referencedDeclaration": 120,
                  "src": "483:14:1",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  }
                }],
                "expression": {
                  "argumentTypes": [{
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  }],
                  "id": 143,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": false,
                  "lValueRequested": false,
                  "nodeType": "NewExpression",
                  "src": "459:23:1",
                  "typeDescriptions": {
                    "typeIdentifier": "t_function_creation_nonpayable$_t_address_$returns$_t_contract$_UpgradeabilityProxy_$1600_$",
                    "typeString": "function (address) returns (contract UpgradeabilityProxy)"
                  },
                  "typeName": {
                    "contractScope": null,
                    "id": 142,
                    "name": "UpgradeabilityProxy",
                    "nodeType": "UserDefinedTypeName",
                    "referencedDeclaration": 1600,
                    "src": "463:19:1",
                    "typeDescriptions": {
                      "typeIdentifier": "t_contract$_UpgradeabilityProxy_$1600",
                      "typeString": "contract UpgradeabilityProxy"
                    }
                  }
                },
                "id": 145,
                "isConstant": false,
                "isLValue": false,
                "isPure": false,
                "kind": "functionCall",
                "lValueRequested": false,
                "names": [],
                "nodeType": "FunctionCall",
                "src": "459:39:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_contract$_UpgradeabilityProxy_$1600",
                  "typeString": "contract UpgradeabilityProxy"
                }
              }],
              "expression": {
                "argumentTypes": [{
                  "typeIdentifier": "t_contract$_UpgradeabilityProxy_$1600",
                  "typeString": "contract UpgradeabilityProxy"
                }],
                "id": 141,
                "name": "Nifty",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 102,
                "src": "453:5:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_type$_t_contract$_Nifty_$102_$",
                  "typeString": "type(contract Nifty)"
                }
              },
              "id": 146,
              "isConstant": false,
              "isLValue": false,
              "isPure": false,
              "kind": "typeConversion",
              "lValueRequested": false,
              "names": [],
              "nodeType": "FunctionCall",
              "src": "453:46:1",
              "typeDescriptions": {
                "typeIdentifier": "t_contract$_Nifty_$102",
                "typeString": "contract Nifty"
              }
            },
            "nodeType": "VariableDeclarationStatement",
            "src": "439:60:1"
          }, {
            "expression": {
              "argumentTypes": null,
              "arguments": [{
                "argumentTypes": null,
                "expression": {
                  "argumentTypes": null,
                  "id": 151,
                  "name": "msg",
                  "nodeType": "Identifier",
                  "overloadedDeclarations": [],
                  "referencedDeclaration": 1615,
                  "src": "522:3:1",
                  "typeDescriptions": {
                    "typeIdentifier": "t_magic_message",
                    "typeString": "msg"
                  }
                },
                "id": 152,
                "isConstant": false,
                "isLValue": false,
                "isPure": false,
                "lValueRequested": false,
                "memberName": "sender",
                "nodeType": "MemberAccess",
                "referencedDeclaration": null,
                "src": "522:10:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }
              }, {
                "argumentTypes": null,
                "id": 153,
                "name": "_name",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 132,
                "src": "534:5:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }
              }, {
                "argumentTypes": null,
                "id": 154,
                "name": "_symbol",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 134,
                "src": "541:7:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }
              }, {
                "argumentTypes": null,
                "id": 155,
                "name": "_metadata",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 136,
                "src": "550:9:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }
              }],
              "expression": {
                "argumentTypes": [{
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }, {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }, {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }, {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }],
                "expression": {
                  "argumentTypes": null,
                  "id": 148,
                  "name": "token",
                  "nodeType": "Identifier",
                  "overloadedDeclarations": [],
                  "referencedDeclaration": 140,
                  "src": "505:5:1",
                  "typeDescriptions": {
                    "typeIdentifier": "t_contract$_Nifty_$102",
                    "typeString": "contract Nifty"
                  }
                },
                "id": 150,
                "isConstant": false,
                "isLValue": false,
                "isPure": false,
                "lValueRequested": false,
                "memberName": "initialize",
                "nodeType": "MemberAccess",
                "referencedDeclaration": 54,
                "src": "505:16:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_function_external_nonpayable$_t_address_$_t_string_memory_ptr_$_t_string_memory_ptr_$_t_string_memory_ptr_$returns$__$",
                  "typeString": "function (address,string memory,string memory,string memory) external"
                }
              },
              "id": 156,
              "isConstant": false,
              "isLValue": false,
              "isPure": false,
              "kind": "functionCall",
              "lValueRequested": false,
              "names": [],
              "nodeType": "FunctionCall",
              "src": "505:55:1",
              "typeDescriptions": {
                "typeIdentifier": "t_tuple$__$",
                "typeString": "tuple()"
              }
            },
            "id": 157,
            "nodeType": "ExpressionStatement",
            "src": "505:55:1"
          }, {
            "eventCall": {
              "argumentTypes": null,
              "arguments": [{
                "argumentTypes": null,
                "expression": {
                  "argumentTypes": null,
                  "id": 159,
                  "name": "msg",
                  "nodeType": "Identifier",
                  "overloadedDeclarations": [],
                  "referencedDeclaration": 1615,
                  "src": "580:3:1",
                  "typeDescriptions": {
                    "typeIdentifier": "t_magic_message",
                    "typeString": "msg"
                  }
                },
                "id": 160,
                "isConstant": false,
                "isLValue": false,
                "isPure": false,
                "lValueRequested": false,
                "memberName": "sender",
                "nodeType": "MemberAccess",
                "referencedDeclaration": null,
                "src": "580:10:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }
              }, {
                "argumentTypes": null,
                "id": 161,
                "name": "token",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 140,
                "src": "592:5:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_contract$_Nifty_$102",
                  "typeString": "contract Nifty"
                }
              }, {
                "argumentTypes": null,
                "id": 162,
                "name": "_name",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 132,
                "src": "599:5:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }
              }, {
                "argumentTypes": null,
                "id": 163,
                "name": "_symbol",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 134,
                "src": "606:7:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }
              }, {
                "argumentTypes": null,
                "id": 164,
                "name": "_metadata",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 136,
                "src": "615:9:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }
              }],
              "expression": {
                "argumentTypes": [{
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }, {
                  "typeIdentifier": "t_contract$_Nifty_$102",
                  "typeString": "contract Nifty"
                }, {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }, {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }, {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }],
                "id": 158,
                "name": "Created",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 118,
                "src": "572:7:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_address_$_t_string_memory_ptr_$_t_string_memory_ptr_$_t_string_memory_ptr_$returns$__$",
                  "typeString": "function (address,address,string memory,string memory,string memory)"
                }
              },
              "id": 165,
              "isConstant": false,
              "isLValue": false,
              "isPure": false,
              "kind": "functionCall",
              "lValueRequested": false,
              "names": [],
              "nodeType": "FunctionCall",
              "src": "572:53:1",
              "typeDescriptions": {
                "typeIdentifier": "t_tuple$__$",
                "typeString": "tuple()"
              }
            },
            "id": 166,
            "nodeType": "EmitStatement",
            "src": "567:58:1"
          }]
        },
        "documentation": null,
        "id": 168,
        "implemented": true,
        "isConstructor": false,
        "isDeclaredConst": false,
        "modifiers": [],
        "name": "create",
        "nodeType": "FunctionDefinition",
        "parameters": {
          "id": 137,
          "nodeType": "ParameterList",
          "parameters": [{
            "constant": false,
            "id": 132,
            "name": "_name",
            "nodeType": "VariableDeclaration",
            "scope": 168,
            "src": "378:12:1",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 131,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "378:6:1",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 134,
            "name": "_symbol",
            "nodeType": "VariableDeclaration",
            "scope": 168,
            "src": "392:14:1",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 133,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "392:6:1",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 136,
            "name": "_metadata",
            "nodeType": "VariableDeclaration",
            "scope": 168,
            "src": "408:16:1",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 135,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "408:6:1",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }],
          "src": "377:48:1"
        },
        "payable": false,
        "returnParameters": {
          "id": 138,
          "nodeType": "ParameterList",
          "parameters": [],
          "src": "433:0:1"
        },
        "scope": 169,
        "src": "362:268:1",
        "stateMutability": "nonpayable",
        "superFunction": null,
        "visibility": "public"
      }],
      "scope": 170,
      "src": "117:515:1"
    }],
    "src": "0:633:1"
  },
  "legacyAST": {
    "absolutePath": "/Users/sfeibus/fs/libraries/statesauce/nifty-supply/packages/contracts/contracts/NiftyFactory.sol",
    "exportedSymbols": {
      "NiftyFactory": [169]
    },
    "id": 170,
    "nodeType": "SourceUnit",
    "nodes": [{
      "id": 104,
      "literals": ["solidity", "^", "0.4", ".18"],
      "nodeType": "PragmaDirective",
      "src": "0:24:1"
    }, {
      "absolutePath": "zos-lib/contracts/upgradeability/UpgradeabilityProxy.sol",
      "file": "zos-lib/contracts/upgradeability/UpgradeabilityProxy.sol",
      "id": 105,
      "nodeType": "ImportDirective",
      "scope": 170,
      "sourceUnit": 1601,
      "src": "26:66:1",
      "symbolAliases": [],
      "unitAlias": ""
    }, {
      "absolutePath": "/Users/sfeibus/fs/libraries/statesauce/nifty-supply/packages/contracts/contracts/Nifty.sol",
      "file": "./Nifty.sol",
      "id": 106,
      "nodeType": "ImportDirective",
      "scope": 170,
      "sourceUnit": 103,
      "src": "94:21:1",
      "symbolAliases": [],
      "unitAlias": ""
    }, {
      "baseContracts": [],
      "contractDependencies": [1600],
      "contractKind": "contract",
      "documentation": null,
      "fullyImplemented": true,
      "id": 169,
      "linearizedBaseContracts": [169],
      "name": "NiftyFactory",
      "nodeType": "ContractDefinition",
      "nodes": [{
        "anonymous": false,
        "documentation": null,
        "id": 118,
        "name": "Created",
        "nodeType": "EventDefinition",
        "parameters": {
          "id": 117,
          "nodeType": "ParameterList",
          "parameters": [{
            "constant": false,
            "id": 108,
            "indexed": true,
            "name": "owner",
            "nodeType": "VariableDeclaration",
            "scope": 118,
            "src": "157:21:1",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_address",
              "typeString": "address"
            },
            "typeName": {
              "id": 107,
              "name": "address",
              "nodeType": "ElementaryTypeName",
              "src": "157:7:1",
              "typeDescriptions": {
                "typeIdentifier": "t_address",
                "typeString": "address"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 110,
            "indexed": false,
            "name": "token",
            "nodeType": "VariableDeclaration",
            "scope": 118,
            "src": "180:13:1",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_address",
              "typeString": "address"
            },
            "typeName": {
              "id": 109,
              "name": "address",
              "nodeType": "ElementaryTypeName",
              "src": "180:7:1",
              "typeDescriptions": {
                "typeIdentifier": "t_address",
                "typeString": "address"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 112,
            "indexed": false,
            "name": "name",
            "nodeType": "VariableDeclaration",
            "scope": 118,
            "src": "195:11:1",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 111,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "195:6:1",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 114,
            "indexed": false,
            "name": "symbol",
            "nodeType": "VariableDeclaration",
            "scope": 118,
            "src": "208:13:1",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 113,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "208:6:1",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 116,
            "indexed": false,
            "name": "metadata",
            "nodeType": "VariableDeclaration",
            "scope": 118,
            "src": "223:15:1",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 115,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "223:6:1",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }],
          "src": "156:83:1"
        },
        "src": "143:97:1"
      }, {
        "constant": false,
        "id": 120,
        "name": "implementation",
        "nodeType": "VariableDeclaration",
        "scope": 169,
        "src": "244:29:1",
        "stateVariable": true,
        "storageLocation": "default",
        "typeDescriptions": {
          "typeIdentifier": "t_address",
          "typeString": "address"
        },
        "typeName": {
          "id": 119,
          "name": "address",
          "nodeType": "ElementaryTypeName",
          "src": "244:7:1",
          "typeDescriptions": {
            "typeIdentifier": "t_address",
            "typeString": "address"
          }
        },
        "value": null,
        "visibility": "public"
      }, {
        "body": {
          "id": 129,
          "nodeType": "Block",
          "src": "315:43:1",
          "statements": [{
            "expression": {
              "argumentTypes": null,
              "id": 127,
              "isConstant": false,
              "isLValue": false,
              "isPure": false,
              "lValueRequested": false,
              "leftHandSide": {
                "argumentTypes": null,
                "id": 125,
                "name": "implementation",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 120,
                "src": "321:14:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }
              },
              "nodeType": "Assignment",
              "operator": "=",
              "rightHandSide": {
                "argumentTypes": null,
                "id": 126,
                "name": "_implementation",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 122,
                "src": "338:15:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }
              },
              "src": "321:32:1",
              "typeDescriptions": {
                "typeIdentifier": "t_address",
                "typeString": "address"
              }
            },
            "id": 128,
            "nodeType": "ExpressionStatement",
            "src": "321:32:1"
          }]
        },
        "documentation": null,
        "id": 130,
        "implemented": true,
        "isConstructor": true,
        "isDeclaredConst": false,
        "modifiers": [],
        "name": "",
        "nodeType": "FunctionDefinition",
        "parameters": {
          "id": 123,
          "nodeType": "ParameterList",
          "parameters": [{
            "constant": false,
            "id": 122,
            "name": "_implementation",
            "nodeType": "VariableDeclaration",
            "scope": 130,
            "src": "290:23:1",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_address",
              "typeString": "address"
            },
            "typeName": {
              "id": 121,
              "name": "address",
              "nodeType": "ElementaryTypeName",
              "src": "290:7:1",
              "typeDescriptions": {
                "typeIdentifier": "t_address",
                "typeString": "address"
              }
            },
            "value": null,
            "visibility": "internal"
          }],
          "src": "289:25:1"
        },
        "payable": false,
        "returnParameters": {
          "id": 124,
          "nodeType": "ParameterList",
          "parameters": [],
          "src": "315:0:1"
        },
        "scope": 169,
        "src": "278:80:1",
        "stateMutability": "nonpayable",
        "superFunction": null,
        "visibility": "public"
      }, {
        "body": {
          "id": 167,
          "nodeType": "Block",
          "src": "433:197:1",
          "statements": [{
            "assignments": [140],
            "declarations": [{
              "constant": false,
              "id": 140,
              "name": "token",
              "nodeType": "VariableDeclaration",
              "scope": 168,
              "src": "439:11:1",
              "stateVariable": false,
              "storageLocation": "default",
              "typeDescriptions": {
                "typeIdentifier": "t_contract$_Nifty_$102",
                "typeString": "contract Nifty"
              },
              "typeName": {
                "contractScope": null,
                "id": 139,
                "name": "Nifty",
                "nodeType": "UserDefinedTypeName",
                "referencedDeclaration": 102,
                "src": "439:5:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_contract$_Nifty_$102",
                  "typeString": "contract Nifty"
                }
              },
              "value": null,
              "visibility": "internal"
            }],
            "id": 147,
            "initialValue": {
              "argumentTypes": null,
              "arguments": [{
                "argumentTypes": null,
                "arguments": [{
                  "argumentTypes": null,
                  "id": 144,
                  "name": "implementation",
                  "nodeType": "Identifier",
                  "overloadedDeclarations": [],
                  "referencedDeclaration": 120,
                  "src": "483:14:1",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  }
                }],
                "expression": {
                  "argumentTypes": [{
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  }],
                  "id": 143,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": false,
                  "lValueRequested": false,
                  "nodeType": "NewExpression",
                  "src": "459:23:1",
                  "typeDescriptions": {
                    "typeIdentifier": "t_function_creation_nonpayable$_t_address_$returns$_t_contract$_UpgradeabilityProxy_$1600_$",
                    "typeString": "function (address) returns (contract UpgradeabilityProxy)"
                  },
                  "typeName": {
                    "contractScope": null,
                    "id": 142,
                    "name": "UpgradeabilityProxy",
                    "nodeType": "UserDefinedTypeName",
                    "referencedDeclaration": 1600,
                    "src": "463:19:1",
                    "typeDescriptions": {
                      "typeIdentifier": "t_contract$_UpgradeabilityProxy_$1600",
                      "typeString": "contract UpgradeabilityProxy"
                    }
                  }
                },
                "id": 145,
                "isConstant": false,
                "isLValue": false,
                "isPure": false,
                "kind": "functionCall",
                "lValueRequested": false,
                "names": [],
                "nodeType": "FunctionCall",
                "src": "459:39:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_contract$_UpgradeabilityProxy_$1600",
                  "typeString": "contract UpgradeabilityProxy"
                }
              }],
              "expression": {
                "argumentTypes": [{
                  "typeIdentifier": "t_contract$_UpgradeabilityProxy_$1600",
                  "typeString": "contract UpgradeabilityProxy"
                }],
                "id": 141,
                "name": "Nifty",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 102,
                "src": "453:5:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_type$_t_contract$_Nifty_$102_$",
                  "typeString": "type(contract Nifty)"
                }
              },
              "id": 146,
              "isConstant": false,
              "isLValue": false,
              "isPure": false,
              "kind": "typeConversion",
              "lValueRequested": false,
              "names": [],
              "nodeType": "FunctionCall",
              "src": "453:46:1",
              "typeDescriptions": {
                "typeIdentifier": "t_contract$_Nifty_$102",
                "typeString": "contract Nifty"
              }
            },
            "nodeType": "VariableDeclarationStatement",
            "src": "439:60:1"
          }, {
            "expression": {
              "argumentTypes": null,
              "arguments": [{
                "argumentTypes": null,
                "expression": {
                  "argumentTypes": null,
                  "id": 151,
                  "name": "msg",
                  "nodeType": "Identifier",
                  "overloadedDeclarations": [],
                  "referencedDeclaration": 1615,
                  "src": "522:3:1",
                  "typeDescriptions": {
                    "typeIdentifier": "t_magic_message",
                    "typeString": "msg"
                  }
                },
                "id": 152,
                "isConstant": false,
                "isLValue": false,
                "isPure": false,
                "lValueRequested": false,
                "memberName": "sender",
                "nodeType": "MemberAccess",
                "referencedDeclaration": null,
                "src": "522:10:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }
              }, {
                "argumentTypes": null,
                "id": 153,
                "name": "_name",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 132,
                "src": "534:5:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }
              }, {
                "argumentTypes": null,
                "id": 154,
                "name": "_symbol",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 134,
                "src": "541:7:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }
              }, {
                "argumentTypes": null,
                "id": 155,
                "name": "_metadata",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 136,
                "src": "550:9:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }
              }],
              "expression": {
                "argumentTypes": [{
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }, {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }, {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }, {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }],
                "expression": {
                  "argumentTypes": null,
                  "id": 148,
                  "name": "token",
                  "nodeType": "Identifier",
                  "overloadedDeclarations": [],
                  "referencedDeclaration": 140,
                  "src": "505:5:1",
                  "typeDescriptions": {
                    "typeIdentifier": "t_contract$_Nifty_$102",
                    "typeString": "contract Nifty"
                  }
                },
                "id": 150,
                "isConstant": false,
                "isLValue": false,
                "isPure": false,
                "lValueRequested": false,
                "memberName": "initialize",
                "nodeType": "MemberAccess",
                "referencedDeclaration": 54,
                "src": "505:16:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_function_external_nonpayable$_t_address_$_t_string_memory_ptr_$_t_string_memory_ptr_$_t_string_memory_ptr_$returns$__$",
                  "typeString": "function (address,string memory,string memory,string memory) external"
                }
              },
              "id": 156,
              "isConstant": false,
              "isLValue": false,
              "isPure": false,
              "kind": "functionCall",
              "lValueRequested": false,
              "names": [],
              "nodeType": "FunctionCall",
              "src": "505:55:1",
              "typeDescriptions": {
                "typeIdentifier": "t_tuple$__$",
                "typeString": "tuple()"
              }
            },
            "id": 157,
            "nodeType": "ExpressionStatement",
            "src": "505:55:1"
          }, {
            "eventCall": {
              "argumentTypes": null,
              "arguments": [{
                "argumentTypes": null,
                "expression": {
                  "argumentTypes": null,
                  "id": 159,
                  "name": "msg",
                  "nodeType": "Identifier",
                  "overloadedDeclarations": [],
                  "referencedDeclaration": 1615,
                  "src": "580:3:1",
                  "typeDescriptions": {
                    "typeIdentifier": "t_magic_message",
                    "typeString": "msg"
                  }
                },
                "id": 160,
                "isConstant": false,
                "isLValue": false,
                "isPure": false,
                "lValueRequested": false,
                "memberName": "sender",
                "nodeType": "MemberAccess",
                "referencedDeclaration": null,
                "src": "580:10:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }
              }, {
                "argumentTypes": null,
                "id": 161,
                "name": "token",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 140,
                "src": "592:5:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_contract$_Nifty_$102",
                  "typeString": "contract Nifty"
                }
              }, {
                "argumentTypes": null,
                "id": 162,
                "name": "_name",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 132,
                "src": "599:5:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }
              }, {
                "argumentTypes": null,
                "id": 163,
                "name": "_symbol",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 134,
                "src": "606:7:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }
              }, {
                "argumentTypes": null,
                "id": 164,
                "name": "_metadata",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 136,
                "src": "615:9:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }
              }],
              "expression": {
                "argumentTypes": [{
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }, {
                  "typeIdentifier": "t_contract$_Nifty_$102",
                  "typeString": "contract Nifty"
                }, {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }, {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }, {
                  "typeIdentifier": "t_string_memory_ptr",
                  "typeString": "string memory"
                }],
                "id": 158,
                "name": "Created",
                "nodeType": "Identifier",
                "overloadedDeclarations": [],
                "referencedDeclaration": 118,
                "src": "572:7:1",
                "typeDescriptions": {
                  "typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_address_$_t_string_memory_ptr_$_t_string_memory_ptr_$_t_string_memory_ptr_$returns$__$",
                  "typeString": "function (address,address,string memory,string memory,string memory)"
                }
              },
              "id": 165,
              "isConstant": false,
              "isLValue": false,
              "isPure": false,
              "kind": "functionCall",
              "lValueRequested": false,
              "names": [],
              "nodeType": "FunctionCall",
              "src": "572:53:1",
              "typeDescriptions": {
                "typeIdentifier": "t_tuple$__$",
                "typeString": "tuple()"
              }
            },
            "id": 166,
            "nodeType": "EmitStatement",
            "src": "567:58:1"
          }]
        },
        "documentation": null,
        "id": 168,
        "implemented": true,
        "isConstructor": false,
        "isDeclaredConst": false,
        "modifiers": [],
        "name": "create",
        "nodeType": "FunctionDefinition",
        "parameters": {
          "id": 137,
          "nodeType": "ParameterList",
          "parameters": [{
            "constant": false,
            "id": 132,
            "name": "_name",
            "nodeType": "VariableDeclaration",
            "scope": 168,
            "src": "378:12:1",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 131,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "378:6:1",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 134,
            "name": "_symbol",
            "nodeType": "VariableDeclaration",
            "scope": 168,
            "src": "392:14:1",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 133,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "392:6:1",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }, {
            "constant": false,
            "id": 136,
            "name": "_metadata",
            "nodeType": "VariableDeclaration",
            "scope": 168,
            "src": "408:16:1",
            "stateVariable": false,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_string_memory_ptr",
              "typeString": "string"
            },
            "typeName": {
              "id": 135,
              "name": "string",
              "nodeType": "ElementaryTypeName",
              "src": "408:6:1",
              "typeDescriptions": {
                "typeIdentifier": "t_string_storage_ptr",
                "typeString": "string"
              }
            },
            "value": null,
            "visibility": "internal"
          }],
          "src": "377:48:1"
        },
        "payable": false,
        "returnParameters": {
          "id": 138,
          "nodeType": "ParameterList",
          "parameters": [],
          "src": "433:0:1"
        },
        "scope": 169,
        "src": "362:268:1",
        "stateMutability": "nonpayable",
        "superFunction": null,
        "visibility": "public"
      }],
      "scope": 170,
      "src": "117:515:1"
    }],
    "src": "0:633:1"
  },
  "compiler": {
    "name": "solc",
    "version": "0.4.24+commit.e67f0147.Emscripten.clang"
  },
  "networks": {
    "15": {
      "events": {},
      "links": {},
      "address": "0xf25186B5081Ff5cE73482AD761DB0eB0d25abfBF",
      "transactionHash": "0x895f8f1d7f753eea3510a9b6e6b0be3ba8b3a762757d8b74ac91491f05d70860"
    }
  },
  "schemaVersion": "3.0.0-beta.1",
  "updatedAt": "2018-11-15T21:37:44.497Z"
};